import { type Conversation } from "shared/apiClient";
import { AssessmentLights } from "shared/types";
import { getText } from "shared/lib";

import { ExternalLinkIcon } from "shared/components";

export interface EGProps {
  assessmentLights: string;
  conversation: Conversation | undefined | null;
}

export function EG({ assessmentLights }: EGProps) {
  const renderRequestFormalAdvice = () => {
    return (
      <div>
        <h3 className="text-headingmd">{getText("Request formal advice")}</h3>
        <p className="text-bodymd mb-2">
          {getText(
            "To receive a written response reviewed by a Council planner, you should submit a request at the link below. This paid service provides you with written confirmation on whether a planning permit is required for your proposal.",
          )}
        </p>
        <a
          className="text-textLink hover:text-textLinkHover text-bodymd inline-flex cursor-pointer underline"
          href="https://www.eastgippsland.vic.gov.au/forms/request-for-written-planning-advice"
          rel="noreferrer"
          tabIndex={0}
          target="_blank"
        >
          {getText("Request advice")}
          <ExternalLinkIcon className="ml-2 mt-[3px]" />
        </a>
      </div>
    );
  };

  const renderRequestFormalAdvice3 = () => {
    return (
      <div>
        <h3 className="text-headingmd">{getText("Request formal advice")}</h3>
        <p className="text-bodymd mb-2">
          {getText(
            "If you wish to have this report and your proposal reviewed by a Council planner, you should submit a request at the link below. This paid service provides you with written confirmation on whether a planning permit is required.",
          )}
        </p>
        <a
          className="text-textLink hover:text-textLinkHover text-bodymd inline-flex cursor-pointer underline"
          href="https://www.eastgippsland.vic.gov.au/forms/request-for-written-planning-advice"
          rel="noreferrer"
          tabIndex={0}
          target="_blank"
        >
          {getText("Request advice")}
          <ExternalLinkIcon className="ml-2 mt-[3px]" />
        </a>
      </div>
    );
  };

  const renderRequestFormalAdvice4 = () => {
    return (
      <div>
        <h3 className="text-headingmd">{getText("Request formal advice")}</h3>
        <p className="text-bodymd mb-2">
          {getText(
            "If you wish to have this report and your proposal reviewed by a Council planner, you should submit a request at the link below. This paid service provides you with written confirmation on whether your proposal is prohibited.",
          )}
        </p>
        <a
          className="text-textLink hover:text-textLinkHover text-bodymd inline-flex cursor-pointer underline"
          href="https://www.eastgippsland.vic.gov.au/forms/request-for-written-planning-advice"
          rel="noreferrer"
          tabIndex={0}
          target="_blank"
        >
          {getText("Request advice")}
          <ExternalLinkIcon className="ml-2 mt-[3px]" />
        </a>
      </div>
    );
  };

  const renderReviewBuildingRequirements1 = () => {
    return (
      <div>
        <h3 className="text-headingmd">
          {getText("Review Building requirements")}
        </h3>
        <p className="text-bodymd mb-2">
          {getText(
            "If you do not require a planning permit, Building Permit requirements may still apply. Information regarding these requirements can be found on Council's website at the following link.",
          )}
        </p>
        <a
          className="text-textLink hover:text-textLinkHover text-bodymd inline-flex cursor-pointer underline"
          href="https://www.eastgippsland.vic.gov.au/building-and-development/building"
          rel="noreferrer"
          tabIndex={0}
          target="_blank"
        >
          {getText("Building requirements")}
          <ExternalLinkIcon className="ml-2 mt-[3px]" />
        </a>
      </div>
    );
  };

  const renderReviewBuildingRequirements2 = () => {
    return (
      <div>
        <h3 className="text-headingmd">
          {getText("Review Building requirements")}
        </h3>
        <p className="text-bodymd mb-2">
          {getText(
            "Although you may not require a planning permit, Building Permit requirements may still apply. Information regarding these requirements can be found on Council's website at the following link.",
          )}
        </p>
        <a
          className="text-textLink hover:text-textLinkHover text-bodymd inline-flex cursor-pointer underline"
          href="https://www.eastgippsland.vic.gov.au/building-and-development/building"
          rel="noreferrer"
          tabIndex={0}
          target="_blank"
        >
          {getText("Building requirements")}
          <ExternalLinkIcon className="ml-2 mt-[3px]" />
        </a>
      </div>
    );
  };

  const renderDownloadCopyOfTitle = () => {
    return (
      <div>
        <h3 className="text-headingmd">
          {getText("Download a copy of title")}
        </h3>
        <p className="text-bodymd mb-2">
          {getText(
            "This tool doesn't consider covenants, caveats and easements which can impact what you are allowed to do. This information is found on the Certificate of Title for your property. A copy of your Certificate of Title can be purchased and downloaded via the following link.",
          )}
        </p>
        <a
          className="text-textLink hover:text-textLinkHover text-bodymd inline-flex cursor-pointer underline"
          href="https://www.landata.online"
          rel="noreferrer"
          tabIndex={0}
          target="_blank"
        >
          {getText("Request a Certificate of Title")}
          <ExternalLinkIcon className="ml-2 mt-[3px]" />
        </a>
      </div>
    );
  };

  const renderContactACouncilPlanner = () => {
    return (
      <div>
        <h3 className="text-headingmd">
          {getText("Contact a Council planner")}
        </h3>
        <p className="text-bodymd mb-2">
          {getText(
            "If you have any questions, you can contact a Council Planner to discuss your report between 8.30am and 5pm Monday to Friday on (03) 5153 9500.",
          )}
        </p>
      </div>
    );
  };

  const renderClarifyInsufficientInfo = () => {
    return (
      <div>
        <h3 className="text-headingmd">
          {getText(
            "Clarify 'insufficient information' by contacting a Council planner",
          )}
        </h3>
        <p className="text-bodymd mb-2">
          {getText(
            "Some information in your report is unclear. Discussing your proposal with a Council planner may result in a planning permit not being required. You can contact a Council planner to discuss your report between 8.30am and 5pm Monday to Friday on (03) 5153 9500.",
          )}
        </p>
      </div>
    );
  };

  const renderSpeakWithCouncilPlanner = () => {
    return (
      <div>
        <h3 className="text-headingmd">
          {getText("Speak with a Council planner")}
        </h3>
        <p className="text-bodymd mb-2">
          {getText(
            "In order to best prepare to submit a complete planning application, you can contact a Council planner to discuss your report between 8.30am and 5pm Monday to Friday on (03) 5153 9500.",
          )}
        </p>
      </div>
    );
  };

  const renderSpeakWithCouncilPlanner4 = () => {
    return (
      <div>
        <h3 className="text-headingmd">
          {getText("Speak with a Council planner")}
        </h3>
        <p className="text-bodymd mb-2">
          {getText(
            "Although a Prohibited land use can be disappointing, a conversation with a Council planner may assist in understanding your options. You can contact a Council planner between 8.30am and 5pm Monday to Friday on (03) 5153 9500.",
          )}
        </p>
      </div>
    );
  };

  const renderPreparePlanningApplication = () => {
    return (
      <div>
        <h3 className="text-headingmd">
          {getText("Preparing a planning application")}
        </h3>
        <p className="text-bodymd mb-2">
          {getText(
            "General advice regarding the minimum information required to prepare a planning application can be found at the following link. If you are not familiar with the planning application process, it is recommended to discuss your proposal with a Council planner between 8.30am and 5pm Monday to Friday on (03) 5153 9500.",
          )}
        </p>
        <a
          className="text-textLink hover:text-textLinkHover text-bodymd inline-flex cursor-pointer underline"
          href="https://www.eastgippsland.vic.gov.au/building-and-development/planning-permits"
          rel="noreferrer"
          tabIndex={0}
          target="_blank"
        >
          {getText("Minimum information required")}
          <ExternalLinkIcon className="ml-2 mt-[3px]" />
        </a>
      </div>
    );
  };

  const renderSubmitApplication = () => {
    return (
      <div>
        <h3 className="text-headingmd">
          {getText("Submit your planning application")}
        </h3>
        <p className="text-bodymd mb-2">
          {getText(
            "If you are ready to submit your planning application, you can connect to Council's website and submit your planning application online at the following link.",
          )}
        </p>
        <a
          className="text-textLink hover:text-textLinkHover text-bodymd inline-flex cursor-pointer underline"
          href="https://www.eastgippsland.vic.gov.au/forms/application-for-planning-permit"
          rel="noreferrer"
          tabIndex={0}
          target="_blank"
        >
          {getText("Submit application")}
          <ExternalLinkIcon className="ml-2 mt-[3px]" />
        </a>
      </div>
    );
  };

  const renderSeekProfessionalSupport = () => {
    return (
      <div>
        <h3 className="text-headingmd">
          {getText("Seek professional support from a planning consultant")}
        </h3>
        <p className="text-bodymd mb-2">
          {getText(
            "The planning application process can be complex and you may benefit from professional advice from a planning consultant.",
          )}
        </p>
      </div>
    );
  };

  switch (assessmentLights) {
    case AssessmentLights.NoPermitRequired:
      return (
        <>
          {renderRequestFormalAdvice()}
          {renderReviewBuildingRequirements1()}
          {renderDownloadCopyOfTitle()}
          {renderContactACouncilPlanner()}
        </>
      );
    case AssessmentLights.MoreInformationRequired:
      return (
        <>
          {renderRequestFormalAdvice()}
          {renderReviewBuildingRequirements2()}
          {renderDownloadCopyOfTitle()}
          {renderClarifyInsufficientInfo()}
        </>
      );
    case AssessmentLights.RequiresPermit:
      return (
        <>
          {renderSpeakWithCouncilPlanner()}
          {renderPreparePlanningApplication()}
          {renderSubmitApplication()}
          {renderRequestFormalAdvice3()}
          {renderDownloadCopyOfTitle()}
          {renderSeekProfessionalSupport()}
        </>
      );
    case AssessmentLights.Prohibited:
      return (
        <>
          {renderSpeakWithCouncilPlanner4()}
          {renderRequestFormalAdvice4()}
          {renderDownloadCopyOfTitle()}
        </>
      );
  }
}
